import { render, staticRenderFns } from "./BatamPpvcFactory.vue?vue&type=template&id=d29652ca&scoped=true&"
import script from "./BatamPpvcFactory.vue?vue&type=script&lang=js&"
export * from "./BatamPpvcFactory.vue?vue&type=script&lang=js&"
import style0 from "./BatamPpvcFactory.vue?vue&type=style&index=0&id=d29652ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29652ca",
  null
  
)

export default component.exports